var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 8.75H1.25v10h1.875c.69 0 1.25-.56 1.25-1.25V10c0-.69-.56-1.25-1.25-1.25zM17.5 8.75h-5.625s1.25-3.75 1.25-5V2.187a.938.938 0 00-.938-.937h-.312c-.33 0-.625.625-.625.625L10 4.375 5.991 8.384a1.25 1.25 0 00-.366.883v6.983a2.5 2.5 0 002.5 2.5h6.357c.332 0 .65-.132.884-.366l3.018-3.018a1.25 1.25 0 00.366-.883V10c0-.69-.56-1.25-1.25-1.25z",
    fill: "#54822B"
  })));
}

export default SvgIconLike;